import React from 'react';
import {
  StyledTooltip,
  StyledContent,
  StyledFooter,
  StyledSkipGroup,
  StyledNavGroup,
  StyledDot,
  StyledTextButton,
  StyledPrimaryButton,
} from './styled';

export default function TourTooltip({
  continuous,
  index,
  step,
  backProps,
  primaryProps,
  skipProps,
  tooltipProps,
  isLastStep,
  size,
  onSkipAll,
}) {
  const { style: _skipStyle, title: _skipTitle, ...skipRest } = skipProps || {};
  const { style: _backStyle, ...backRest } = backProps || {};
  const { style: _primaryStyle, ...primaryRest } = primaryProps || {};

  return (
    <StyledTooltip {...tooltipProps}>
      <StyledContent>{step.content}</StyledContent>
      <StyledFooter>
        <StyledSkipGroup>
          <StyledTextButton {...skipRest} type="button" title="Skip this page">
            Skip
          </StyledTextButton>
          <StyledDot aria-hidden="true">·</StyledDot>
          <StyledTextButton type="button" title="Skip every page" onClick={onSkipAll}>
            Skip all
          </StyledTextButton>
        </StyledSkipGroup>
        <StyledNavGroup>
          {index > 0 && (
            <StyledTextButton {...backRest} type="button">
              Back
            </StyledTextButton>
          )}
          {continuous && (
            <StyledPrimaryButton {...primaryRest} type="button">
              {isLastStep ? 'Done' : 'Next'}
              {size > 1 ? ` (${index + 1}/${size})` : ''}
            </StyledPrimaryButton>
          )}
        </StyledNavGroup>
      </StyledFooter>
    </StyledTooltip>
  );
}
